import { Link } from 'react-router-dom';

interface StubPageProps {
  title: string;
  blurb: string;
  module?: string;
}

/**
 * Placeholder for routes whose module hasn't shipped yet.
 * Keeps the sidebar navigable without 404s.
 */
export function StubPage({ title, blurb, module }: StubPageProps) {
  return (
    <div className="mx-auto max-w-2xl px-8 py-12">
      <div className="rounded-2xl border border-stone-200 bg-white p-8 shadow-sm">
        <div className="text-[10px] uppercase tracking-wider text-stone-400">
          {module ?? 'Coming soon'}
        </div>
        <h1 className="mt-1 text-2xl font-semibold text-stone-800">{title}</h1>
        <p className="mt-4 text-sm leading-relaxed text-stone-600">{blurb}</p>
        <div className="mt-6 text-xs text-stone-500">
          <Link to="/" className="text-[color:var(--sfp-primary)] hover:underline">
            ← Back to home base
          </Link>
        </div>
      </div>
    </div>
  );
}
